import { fromJS } from 'immutable';
// import _ from 'lodash';

import * as revisionHistoryActions from '../actions/revisionHistory';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  results: {
    data: [],
    state: null,
    count: 0,
  },
  resultsInternal: {
    data: [],
    state: null,
    count: 0,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case revisionHistoryActions.REVISION_HISTORY_SEARCH[START]:
      let newState = state.setIn(['results', 'data'], fromJS(null));
      return newState.setIn(['results', 'state'], fetchingState.FETCHING);
    case revisionHistoryActions.REVISION_HISTORY_SEARCH[SUCCESS]:
      newState = state.setIn(['results', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['results', 'count'],
        action.data.results.total,
      );
      return newState.setIn(
        ['results', 'data'],
        fromJS(action.data ? action.data.results.hits : null),
      );
    case revisionHistoryActions.REVISION_HISTORY_SEARCH[ERROR]:
      return state.setIn(['results', 'state'], fetchingState.ERROR);

    case revisionHistoryActions.REVISION_HISTORY_SEARCH_INTERNAL[START]:
      newState = state.setIn(['resultsInternal', 'data'], fromJS(null));
      return newState.setIn(
        ['resultsInternal', 'state'],
        fetchingState.FETCHING,
      );
    case revisionHistoryActions.REVISION_HISTORY_SEARCH_INTERNAL[SUCCESS]:
      newState = state.setIn(
        ['resultsInternal', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['resultsInternal', 'count'],
        action.data.totalRecords,
      );
      return newState.setIn(
        ['resultsInternal', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case revisionHistoryActions.REVISION_HISTORY_SEARCH_INTERNAL[ERROR]:
      return state.setIn(['resultsInternal', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
